import { VITE_BASE_URL } from '@/config';

export function resolveMediaUrl(media) {
  const value = media?.data?.attributes || media?.data || media;
  const url = typeof value === 'string' ? value : value?.url;
  if (!url || typeof url !== 'string') return '';
  if (/^https?:\/\//i.test(url)) return url;
  const base = String(VITE_BASE_URL || '').replace(/\/$/, '');
  return `${base}${url.startsWith('/') ? url : `/${url}`}`;
}

// Основной URL остаётся доступным отдельно: экспорт всегда использует его.
export function imageVariants(media) {
  const image = media?.data?.attributes || media?.data || media;
  if (!image) return [];
  // Строкой передаются готовые URL и локальные ресурсы Vite; медиа API — объектом.
  if (typeof image === 'string') return [{ url: image }];
  const variants = [image, ...Object.values(image.formats || {})]
    .map(value => ({ ...(typeof value === 'object' ? value : {}), url: resolveMediaUrl(value) }))
    .filter(value => value.url);
  return [...new Map(variants.map(value => [value.url, value])).values()]
    .sort((a, b) => (a.width * a.height || Infinity) - (b.width * b.height || Infinity));
}

export function smallestImageUrl(media) {
  return imageVariants(media)[0]?.url || '';
}

export function imageSrcset(media) {
  const variants = imageVariants(media).filter(image => image.width > 0);
  const widths = new Map(variants.map(image => [image.width, image.url]));
  return [...widths].sort(([a], [b]) => a - b).map(([width, url]) => `${url} ${width}w`).join(', ') || undefined;
}

// Для background-size: cover нужны обе стороны, чтобы не растягивать обрезанный фон.
export function imageBackground(media, width, height) {
  const variants = imageVariants(media);
  if (!variants.length) return 'none';
  if (variants.length === 1) return `url(${JSON.stringify(variants[0].url)})`;
  const candidates = [1, 2, 3].map(density => {
    const image = variants.find(item => item.width >= width * density && item.height >= height * density) || variants.at(-1);
    return `url(${JSON.stringify(image.url)}) ${density}x`;
  });
  return `image-set(${candidates.join(', ')})`;
}
